"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("@completeanatomy/config");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const storage_1 = require("@completeanatomy/storage");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const withSharingProvider_1 = __importDefault(require("../../hocs/withSharingProvider"));
const useUserGroups_1 = require("../../hooks/useUserGroups");
const index_1 = require("../../index");
const GroupsManagementMobile_1 = __importDefault(require("../../organisms/GroupsManagementMobile"));
const filter_1 = require("../../utils/filter");
const STORAGE_KEY = 'isSharingTabOpenedFirstTime';
function Sharing() {
    const { isMobile } = (0, device_1.usePlatform)();
    const sharingService = (0, index_1.useSharing)();
    const groups = (0, useUserGroups_1.useUserGroups)();
    const storage = (0, storage_1.useStorageService)();
    const [currentGroup, setCurrentGroup] = (0, react_1.useState)(null);
    const [isCtaCardVisible, setCtaCardVisible] = (0, react_1.useState)((0, filter_1.getFoundedGroups)(groups).length === 0);
    const { t } = (0, i18n_1.useTranslation)();
    (0, ui_1.usePageTitle)(t(i18n_1.Strings.pageTitle.sharing));
    const onGroupSelect = (0, react_1.useCallback)((id) => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.updateLastActivityTime(id);
        setCurrentGroup(id);
    }, [sharingService, setCurrentGroup]);
    (0, react_1.useEffect)(() => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.fetch();
    }, [sharingService, storage]);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            const storageKey = yield (storage === null || storage === void 0 ? void 0 : storage.get(STORAGE_KEY));
            if (!storageKey) {
                storage === null || storage === void 0 ? void 0 : storage.put(STORAGE_KEY, true);
                setCtaCardVisible(true);
            }
        }))();
    }, [storage]);
    (0, react_1.useEffect)(() => {
        if (!isCtaCardVisible) {
            return;
        }
        setCtaCardVisible((0, filter_1.getFoundedGroups)(groups).length === 0);
    }, [isCtaCardVisible, groups]);
    const groupData = groups.find(group => group.identifier === currentGroup);
    return isMobile ? ((0, jsx_runtime_1.jsx)(GroupsManagementMobile_1.default, { groups: groups, isMobile: isMobile, "data-e2e": 'Sharing_GroupsManagementMobile' })) : ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'Sharing_Container', children: [(0, jsx_runtime_1.jsx)(index_1.GroupsManagement, { groups: groups, currentGroup: currentGroup, setCurrentGroup: onGroupSelect, isMobile: isMobile, isCtaCardVisible: isCtaCardVisible, setCtaCardVisible: setCtaCardVisible, "data-e2e": 'Sharing_GroupsManagement' }), (0, jsx_runtime_1.jsx)(DetailsContainer, { "data-e2e": 'Sharing_DetailsContainer', children: groupData && (0, jsx_runtime_1.jsx)(Details, { group: groupData, "data-e2e": 'Sharing_Details' }) })] }));
}
exports.default = Sharing;
exports.SharingPage = (0, config_1.withConfigProvider)((0, storage_1.withStorageProvider)((0, withSharingProvider_1.default)(Sharing)));
const Container = styled_components_1.default.div `
  display: flex;

  width: 100%;
  max-width: ${props => props.theme.maxContentWidth}px;
  height: 100%;

  margin: 0 auto;

  overflow: hidden;

  background-color: ${props => props.theme.background};
`;
const DetailsContainer = styled_components_1.default.div `
  display: flex;
  flex-basis: 40%;
  flex-direction: column;
  flex-shrink: 0;

  min-width: 40%;
  height: 100%;
`;
const Details = (0, styled_components_1.default)(index_1.GroupDetails) `
  width: 100%;

  margin: 80px auto 0 auto;
`;
